import * as React from 'react';
import styled from 'styled-components';
import { rem, rgba } from 'polished';
import { useState } from 'react';
import { FlexRowCenterVertical, TextP } from '../../..';
import { IconType, SvgIcon } from '../General/SvgIcon';
import { RangeFilter } from './RangeFilter';
import { OptionsFilter } from './OptionsFilter';
import { LinksFilter } from './LinksFilter';

enum FilterType {
  RANGE = 'RANGE',
  OPTIONS = 'CHECKBOX',
  LINKS = 'LINKS',
}

interface Props {
  type: FilterType;
  name: string;
  isMobile?: boolean;
  initialIsOpen?: boolean;
  filterData:
    | {
        min: number;
        max: number;
        activeMin: string;
        activeMax: string;
        attribId?: number;
      }
    | { links: Array<{ name: string; url: string }> }
    | { values: any[]; attribId: string };
  handleFilterChange: any;
  activeValues?: any;
  unit?: string;
}

function CategoryFilterDesktop({
  type,
  name,
  initialIsOpen = false,
  isMobile = false,
  filterData,
  handleFilterChange,
  activeValues,
  unit,
}: Props) {
  const [isOpen, setIsOpen] = useState(initialIsOpen);

  const changeIsOpenState = () => {
    setIsOpen(!isOpen);
  };

  return (
    <FilterItem hasGradient={type === FilterType.LINKS} isMobile={isMobile}>
      <ItemTitleWrapper onClick={changeIsOpenState}>
        <ItemTitle>{name}</ItemTitle>
        <SvgIcon
          icon={isOpen ? IconType.chevronUpSmall : IconType.chevronDownSmall}
          width={16}
          height={16}
          viewBox="0 0 16 16"
          cursor={'pointer'}
        />
      </ItemTitleWrapper>
      <FilterWrapper className={isOpen ? 'show' : ''}>
        {isOpen &&
          // (type === FilterType.RANGE ? (
          //   <RangeFilter
          //     handleFilterChange={handleFilterChange}
          //     isOpen={isOpen}
          //     filterData={filterData}
          //     unit={unit}
          //     activeValues={activeValues}
          //   />
          // ) :
          (type === FilterType.OPTIONS ? (
            <OptionsFilter
              handleFilterChange={handleFilterChange}
              isOpen={isOpen}
              filterData={filterData}
              activeValues={activeValues}
            />
          ) : type === FilterType.LINKS ? (
            <LinksFilter isOpen={isOpen} filterData={filterData} />
          ) : null)}
      </FilterWrapper>
    </FilterItem>
  );
}

const FilterItem = styled.div<{
  isMobile: boolean | false;
  hasGradient?: boolean;
}>`
  background: ${({ theme }) => rgba(theme.colors.primary, 0.12)};
  border-radius: ${rem(4)};
  padding: ${rem(32)} ${rem(24)};
  margin-bottom: ${rem(7)};

  ${({ theme }) => theme.mediab.l925`
  margin-bottom: 0;
  border-bottom: ${rem(2)} solid #EEEEEE;
  background: ${theme.colors.white};
  border-radius: 0;
`}
`;

const FilterWrapper = styled.div<{ show?: boolean }>`
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  -moz-transition: opacity 0.3s ease-in-out;
  -webkit-transition: opacity 0.3s ease-in-out;

  &.show {
    opacity: 1;
    visibility: visible;
  }
`;

const TitleIcon = styled(SvgIcon)`
  transition: transform 0.3s ease;
  fill: ${({ theme }) => theme.categoryFilter.color};
`;

const ItemTitle = styled.h4`
  font-size: ${rem(16)};
  line-height: ${rem(24)};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0;
`;

const ItemTitleWrapper = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }) => theme.mediab.l925`
    svg {
      fill: ${theme.colors.black};
    }
  `}
`;

export { CategoryFilterDesktop, FilterType };
